import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { FormikError } from '../formik_error/FormikError'
import styles from './TextAreaField.module.scss'

export const TextAreaField = ({
  classes = {},
  style = {},
  formik,
  field,
  placeholder,
  label,
  isRequired,
  noLabel = false,
  cols,
  rows,
  maxChars,
}: any) => {
  const [charCount, setCharCount] = useState(formik?.values[field]?.length || 0)

  useEffect(() => {
    setCharCount(formik?.values[field]?.length || 0)
  }, [formik?.values[field]])

  const handleChange = (e) => {
    const value = e.target.value
    if (!maxChars || value.length <= maxChars) {
      setCharCount(value.length)
      formik.setFieldValue(field, value)
    }
  }

  return (
    <div className={styles['textarea__container']}>
      {!noLabel && <label className={isRequired ? clsx(styles['label'], styles['required']) : styles['label']}>{label}</label>}

      <textarea
        style={{ ...style.container }}
        rows={rows || '4'}
        cols={cols || '50'}
        placeholder={placeholder}
        name={field}
        autoComplete='off'
        value={formik.values[field] || ''}
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(field, true)}
        className={clsx(
          classes.container,
          styles['TextAreaField'],
          { [styles['is-invalid']]: formik?.touched[field] && formik?.errors[field] },
          { [styles['is-valid']]: formik?.touched[field] && !formik?.errors[field] },
        )}
      />

      {maxChars && (
        <div className={styles['max-chars']}>
          {charCount}/{maxChars}
        </div>
      )}

      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
